import './CartItem.css';
import { useTranslation } from '../../i18n/i18n';
import { ApiCartItem } from '../../types';
import { Link } from 'react-router-dom';
import { QuantityInput } from '../Form/QuantityInput';
import { Img } from '../Img/Img';
import { trash, Icon } from '../Icon/Icon';
import { Button } from '../Form/Button';
import { DeliveryTime } from '../product/DeliveryTime';
import { useAnalytics } from '../../hooks/useAnalytics';
import { useConfig } from '../../config';
import { PriceTagSimple } from '../../components/PriceTagSimple/PriceTagSimple';
import { ProductContainer } from '../../state/product';

type CartItemProps = {
	item: ApiCartItem;
	onSetQuantity: (id: number, quantity: number) => void;
};

export const CartItem = ({ item, onSetQuantity }: CartItemProps) => {
	const { sendEvent } = useAnalytics();
	const config = useConfig();
	const { getFinalPrice } = ProductContainer.useContainer();

	const t = useTranslation().cart;

	function handleRemoveItem() {
		onSetQuantity(item.product.id, 0);
		sendEvent({
			event: 'remove_from_cart',
			ecommerce: {
				currency: config.currencyCode,
				value: item.price.currentPrice,
				items: [
					{
						item_id: String(item.product.id),
						item_name: item.product.name,
						price: item.price.currentPrice,
					},
				],
			},
		});
	}

	const {
		quantity,
		product: { id, name, image, perma, bundleSize, deliveryNotice, deliveryClass },
		price: { currentPrice },
	} = item;

	return (
		<cart-item>
			<Img src={image} width={292} height={292} alt={name} />
			<div className="title">
				<Link to={'/' + perma}>{name}</Link>
			</div>
			<QuantityInput
				defaultValue={quantity}
				onBlur={(value) => onSetQuantity(id, value)}
				step={bundleSize}
				iconSize={17}
			/>

			<span className="delivery">
				<DeliveryTime
					deliveryClass={deliveryClass}
					deliveryNotice={deliveryNotice}
					textLength={'short-one-line'}
				/>
			</span>
			<Button className="clear" onClick={handleRemoveItem}>
				<Icon shape={trash} size={16} /> {t.remove}
			</Button>
			<div className="item-price">
				<PriceTagSimple
					price={getFinalPrice(id, currentPrice, quantity)}
					isCampaign={item.price.special ? true : false}
					vatRate={item.tax * 100}
				></PriceTagSimple>
			</div>
		</cart-item>
	);
};
